/**
 * Text Editing Keyboard Handlers
 * Manages keyboard event listeners with proper cleanup to prevent memory leaks
 */

/**
 * Creates a keyboard listener manager with proper attach/detach lifecycle
 * Prevents memory leaks by ensuring only one listener exists at a time
 *
 * @returns {Object} Manager with attach() and detach() methods
 */
export function createKeyboardListenerManager() {
  let escapeHandler = null;

  return {
    /**
     * Attach escape key listener. Automatically detaches any existing listener first.
     * @param {Function} onEscape - Callback when Escape key is pressed
     */
    attach(onEscape) {
      // Always clean up existing listener first
      this.detach();

      escapeHandler = (e) => {
        if (e.key === 'Escape') {
          onEscape(e);
        }
      };

      window.addEventListener('keydown', escapeHandler);
    },

    /**
     * Detach the escape key listener if one exists
     */
    detach() {
      if (escapeHandler) {
        window.removeEventListener('keydown', escapeHandler);
        escapeHandler = null;
      }
    },

    /**
     * Check if a listener is currently attached
     * @returns {boolean}
     */
    isAttached() {
      return escapeHandler !== null;
    }
  };
}
